var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:"audio",attrs:{"loop":""}},[_c('source',{attrs:{"src":require("../static/alert.mp3"),"type":"audio/mp3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }